import React from 'react';

const LoadingOverlay = ({ isLoading, message = "Please wait..." }) => {
  if (!isLoading) return null;

  return (
    <div 
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(10, 15, 44, 0.85)',
        zIndex: 1000,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <div className="atom">
        <div className="electron"></div>
        <div className="electron electron-alpha"></div>
        <div className="electron electron-omega"></div>
      </div>
      <div style={{ color: '#99f8ff', marginTop: '2rem', fontSize: '1.2rem' }}>{message}</div>
    </div>
  );
};

export default LoadingOverlay; 